import type {
  CriticalActionEvent,
  DomainOfExcellence,
  Entity,
  EntityDict,
  ModuleBuildSettings,
  PlayerBuild,
  PlayerBuildSettings,
  User,
  UserSlim
} from '@webapp2/shared/model'
import { reactive } from 'vue'
import type { MultiplayerSession, PermissionGroup } from '../state'

export const adminState = reactive({
  courseSlims: <EntityDict<EntitySlim>>{},
  multiplayerSessions: <EntityDict<MultiplayerSession>>{},
  organizationSlims: <EntityDict<EntitySlim>>{},
  permissionGroups: <EntityDict<PermissionGroup>>{},
  playerTechniqueSlims: <EntityDict<EntitySlim>>{},
  userSlims: <EntityDict<UserSlim>>{},
  users: <EntityDict<User>>{},
  playerBuilds: <EntityDict<PlayerBuild>>{},
  playerRuns: <EntityDict<AdminPlayerRun>>{},
  moduleBuildSettings: <EntityDict<ModuleBuildSettings>>{},
  playerBuildSettings: <EntityDict<PlayerBuildSettings>>{}
})

export type EntitySlim = Entity & { name: string }

export type Stage = {
  id: string
  name: string
  criticalActions: CriticalAction[]
}

type CriticalAction = {
  id: string
  description: string
  criticalSubActions: CriticalSubAction[] | null
  domainsOfExcellence: DomainOfExcellence[]
}

type CriticalSubAction = {
  id: string
  description: string
  supplySelectionItems: SupplySelectionItem[] | null
}

type SupplySelectionItem = {
  id: string
  name: string
  correct: boolean
  category: SupplyCategory
}

export type SupplyCategory = 'Correct' | 'IncorrectVariant' | 'MiscDecoy'

export type AdminPlayerRun = Entity & {
  id: string
  runLogId: string
  date: string
  userId: string
  organizationId: string
  moduleBuildId?: string
  techniqueId: string
  playerBuildId: string
  multiplayerSessionId?: string
  isTest: boolean
  completed: boolean
  errorWhileProcessing?: string
  level?: number
  hintsUsed?: number
  time: number
  isOsso: boolean
  ranTutorial: boolean
  isTutorialRun: boolean
  courseId?: string
  score?: number
  criticalActions: CriticalActionEvent[]
  hints: HintEvent[]
  isEmbedded: boolean
}

export type HintEvent = {
  id: string
  criticalAction: string
}

export type AdminState = typeof adminState
